import { Award, Globe, FileText, Globe2 } from 'lucide-react';
import { ServicoItem } from './services.types';

export const SERVICOS: ServicoItem[] = [
  {
    key: 'diploma',
    icon: Award,
    titulo: 'Solicitar Diploma/Certificado',
    desc: 'Solicite e receba seu diploma oficial ou certificado de conclusão',
    features: [
      'Diploma em formato digital e físico',
      '2ª via disponível',
      'Validação de QR Code',
      'Entrega em até 10 dias',
    ],
    preco: 'R$ 79,00',
  },
  {
    key: 'cosmetologo',
    icon: Globe,
    titulo: 'Cosmetólogo Internacional',
    desc: 'Credenciais de profissional internacional reconhecida em +100 países',
    features: [
      'Registro internacional',
      'Reconhecimento em +100 países',
      'Carteirinha com foto',
      'Validade de 2 anos',
    ],
    preco: 'R$ 299,00',
  },
  {
    key: 'licenca',
    icon: FileText,
    titulo: 'Licença Profissional',
    desc: 'Documento e validação profissional para atuação no mercado',
    features: [
      'Registro profissional',
      'Validade e comprovação',
      'Documentação organizada',
      'Suporte orientativo',
    ],
    preco: 'R$ 149,00',
  },
  {
    key: 'site',
    icon: Globe2,
    titulo: 'Site Profissional',
    desc: 'Crie seu site profissional com domínio e hospedagem inclusos',
    features: [
      'Domínio personalizado',
      'Design profissional',
      'Hospedagem incluída',
      'Suporte técnico',
    ],
    preco: 'R$ 399/ano',
  },
];
